import axios, { type AxiosInstance } from "axios";

function serializeParams(params: Record<string, unknown>): string {
  const parts: string[] = [];

  function encode(key: string, value: unknown): void {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === "object" && item !== null) {
          Object.entries(item).forEach(([k, v]) => {
            encode(`${key}[${index}].${k}`, v);
          });
        } else {
          encode(`${key}[${index}]`, item);
        }
      });
    } else if (typeof value === "object") {
      Object.entries(value as Record<string, unknown>).forEach(([k, v]) => {
        encode(`${key}.${k}`, v);
      });
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  }

  Object.entries(params).forEach(([key, value]) => encode(key, value));
  return parts.join("&");
}

export default class ApiAcces {
  protected api: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    paramsSerializer: (params) => serializeParams(params as Record<string, unknown>),
  });

  constructor() {
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response?.status === 401 &&
          window.location.pathname.startsWith("/admin")
        ) {
          window.location.href = "/login";
        }

        let errorMessage = error.message;
        if (error.response?.data) {
          if (typeof error.response.data === "string") {
            errorMessage = error.response.data;
          } else if (typeof error.response.data === "object") {
            errorMessage =
              error.response.data.message ||
              error.response.data.detail ||
              error.response.data.error ||
              JSON.stringify(error.response.data);
          }
        }

        const customError = new Error(errorMessage) as Error & { status?: number };
        customError.status = error.response?.status;
        return Promise.reject(customError);
      },
    );
  }
}
